export class Folders {
  constructor(folderContainer, filesContainer) {
    this.foldersContainer = folderContainer;
    this.filesContainer = filesContainer;

    this.activeClass = 'folder__card--active';
    this.loadingClass = 'folder__card--loading';
    this.currentClass = 'folder__card--current';

    this.selectedTarget = null;
    this.isloading = false;
    this.request = null;
    this.searchForm = document.getElementById('search-document-form');

    if (this.foldersContainer) {
      this.init();
    }
  }

  onFolderClick(e) {
    const target = e.target;

    // Abort any previously started AJAX request
    if (this.request) {
      this.request.abort();
    }

    if (!this.isloading) {
      const loading = this.foldersContainer.querySelector('.' + this.loadingClass);
      if (loading) {
        loading.classList.remove(this.loadingClass);
      }
    }

    // Update cards view
    this.toggleFolder(target);

    if (!this.isloading) {
      this.selectedTarget = target;
      this.addLoading();

      const url = target.dataset.fetchFiles;

      this.request = $.ajax(url)
        .done((res) => {
          const dom = res.html;
          if (dom) {
            this.filesContainer.innerHTML = dom;
          }
        })
        .always(() => {
          this.removeLoading();
          this.request = null;
        });
    }
  }

  removeLoading() {
    this.isloading = false;
    this.selectedTarget.classList.remove(this.loadingClass);
  }

  addLoading() {
    this.isloading = true;
    this.selectedTarget.classList.add(this.loadingClass);
  }

  setCurrentFolder($target) {
      if ($target.classList.contains(this.currentClass)) {
          $('.' + this.currentClass).removeClass(this.currentClass);
          $target.classList.remove(this.currentClass);
          $target.classList.remove(this.activeClass);
      } else {
          $('.' + this.currentClass).removeClass(this.currentClass);
          $target.classList.add(this.currentClass);
          $target.classList.add(this.activeClass);
      }
  }

  setActiveFolders($target) {
    // Display the target subdirectories that were initially hidden on page load and update card state
    $target.addClass(this.activeClass);

    // Selects target folder siblings with active class and removes active class
    const targetSibling = $target.parent().siblings().children('.' + this.activeClass);
    targetSibling.removeClass(this.activeClass);
  }

  setCardState(searchInput) {
    let searchQuery = searchInput.value;
    let cards = this.filesContainer.querySelectorAll('.card-wrapper');

    if (cards.length) {
      for (let i = 0; i < cards.length; i++) {
        const card = cards[i];
        const fileName = card.dataset.fileName;

        if (searchQuery === "") {
          card.classList.remove('hidden');
        } else {
          if (fileName.includes(searchQuery)) {
            card.classList.remove('hidden');
          } else {
            card.classList.add('hidden');
          }
        }
      }
    }
  }

  toggleFolder(target) {
    this.setCurrentFolder(target);
  }

  init() {
    const folders = this.foldersContainer.querySelectorAll('.folder__card');

    if (this.searchForm) {
      this.searchForm.addEventListener("submit", (e) => {
        e.preventDefault();
        const searchInput = document.getElementById('filename');

        if (searchInput) {
          this.setCardState(searchInput);
        }
      }, true);
    }

    if (folders.length) {
      for (let i = 0; i < folders.length; i++) {
        const folder = folders[i];
        folder.addEventListener('click', (e) => this.onFolderClick(e));
      }
    }
  }
}
